var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.9838 11.6145C30.105 10.7817 29.5336 10.0075 28.7077 9.88521L20.1706 8.62686L16.3556 0.788216C16.2182 0.549115 16.0211 0.350546 15.7838 0.21231C15.0345 -0.224338 14.0759 0.0340995 13.6427 0.789703L9.82923 8.62686L1.29209 9.8853C0.965694 9.93355 0.66401 10.0882 0.43286 10.3256C-0.151975 10.9262 -0.143031 11.8912 0.452684 12.4808L6.63536 18.5926L5.17636 27.2196C5.16253 27.3021 5.15543 27.3857 5.15525 27.4695C5.15294 28.3124 5.82878 28.9977 6.66486 29C6.91132 28.9996 7.15399 28.9384 7.3715 28.8215L14.9999 24.7549L22.6268 28.82C22.9216 28.9778 23.2598 29.0327 23.5888 28.9762C24.4108 28.8348 24.9636 28.0484 24.8234 27.2196L23.3644 18.5926L29.5486 12.4793C29.7831 12.2465 29.9359 11.9429 29.9838 11.6145ZM22.0249 17.7834C21.8481 17.9583 21.7671 18.2093 21.8081 18.4557L23.3335 27.4738L15.3525 23.2197C15.1315 23.1037 14.8683 23.1037 14.6473 23.2197L6.66634 27.4753L8.19163 18.4558C8.23266 18.2094 8.15171 17.9584 7.97477 17.7834L1.51033 11.3935L10.4414 10.0772C10.688 10.04 10.9008 9.88326 11.0109 9.65773L14.9999 1.46071L18.9888 9.65764C19.0989 9.88317 19.3118 10.0399 19.5583 10.0771L28.4908 11.392L22.0249 17.7834Z",
    fill: "#7F7F7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.0bdf88cc83ef7851d737daf4896699c0.svg";
export { ForwardRef as ReactComponent };